import React, { useState } from 'react'
import { Button, Dropdown, ButtonGroup } from 'react-bootstrap'
import { copyToClipboard } from 'utils/general'

const ShareDropdown = ({ url, trial = false, className = '', buttonText = 'Share' }) => {
  const [showDropdown, setShowDropdown] = useState(false)

  const handleToggleDropdown = () => {
    setShowDropdown(!showDropdown)
  }

  const handleSocialShare = (platform) => {
    const shareUrl = encodeURIComponent(url)
    const title = encodeURIComponent('Check out this link!')

    let socialShareUrl = ''
    switch (platform) {
      case 'facebook':
        socialShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${title}`
        break
      case 'linkedin':
        socialShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`
        break
      default:
        return
    }

    window.open(socialShareUrl, '_blank', 'noopener,noreferrer,width=600,height=400')
    setShowDropdown(false)
  }

  const copyLink = async (text) => {
    copyToClipboard(text)
    setShowDropdown(false)
  }

  return (
    <Dropdown as={ButtonGroup} show={showDropdown} onToggle={handleToggleDropdown}>
      <Button className={className} variant="light" onClick={handleToggleDropdown}>
        <img className="me-2" src="/assets/icons/share.svg" height={16} width={16} alt="Share" />
        {buttonText}
      </Button>
      <Dropdown.Toggle split variant="outline-secondary" id="dropdown-custom-share" className="py-0" />
      <Dropdown.Menu className="super-colors">
        <Dropdown.Item
          eventKey="1"
          className="d-flex gap-2 align-items-baseline"
          onClick={() => handleSocialShare('facebook')}
        >
          <img alt="Facebook" src="/assets/icons/facebook.svg" height={16} width={16} /> Facebook
        </Dropdown.Item>
        <Dropdown.Item
          eventKey="2"
          className="d-flex gap-2 align-items-baseline"
          onClick={() => handleSocialShare('linkedin')}
        >
          <img alt="LinkedIn" src="/assets/icons/linkedin.svg" height={16} width={16} /> LinkedIn
        </Dropdown.Item>
        <Dropdown.Item eventKey="3" className="d-flex gap-2 align-items-baseline" onClick={() => copyLink(url)}>
          <img alt="copy" src="/assets/icons/copy.png" height={16} width={16} /> Copy Share Link
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default ShareDropdown
